module.exports = __webpack_public_path__ + "img/premio5.a4ad658a.jpeg";